export function setupTabs(): void {
    const tabs = ["map", "progress"];

    tabs.forEach((tab) => {
        (document.getElementById(`nav-${tab}`) as HTMLElement).onclick = () => {
            tabs.filter((t) => t !== tab).forEach((t) => {
                (
                    document.getElementById(`panel-${t}`) as HTMLElement
                ).style.display = "none";
            });
            (
                document.getElementById(`panel-${tab}`) as HTMLElement
            ).style.display = "flex";
        };
    });
}
